import { normalizeInstagramPermalinkForEmbed } from "../../../extractor/instagram-embed-extractor";
import { CardPreviewMediaAreaRender } from "./card-preview-media-area-render";
import { CardPreviewTileRender } from "./card-preview-tile-render";
import type { DetectedLinksMap } from "../../../core/sns-detector";
import { snsPreviewManagerForm } from "../../sns-preview-manager-form";
import { Roles } from "../../../../constants/roles";
import { OgpRender } from "../../../../util/ogp/ogp-render";

const ogpRender = new OgpRender();

export class InstagramCardPreviewRender {
    public static addInstagramPreviewToCard(cardElement: Element, detectedLinks: DetectedLinksMap): void {
        if (!detectedLinks.instagram?.length) return;

        const boardMediaArea = CardPreviewMediaAreaRender.findCardMediaArea(cardElement);
        if (!boardMediaArea) return;

        const placeholder = snsPreviewManagerForm.getBoardMediaPlaceholder(boardMediaArea);
        if (!placeholder) return;

        const existing = snsPreviewManagerForm.getExistingPrimaryPreview(boardMediaArea);
        if (existing) return;

        const instagramUrl = String(detectedLinks.instagram[0]?.url || "");
        const permalink = normalizeInstagramPermalinkForEmbed(instagramUrl) || instagramUrl;

        void this.renderInstagramCardPreview(boardMediaArea, placeholder, permalink);
    }

    private static async renderInstagramCardPreview(
        boardMediaArea: HTMLElement,
        placeholder: HTMLElement,
        permalink: string,
    ): Promise<void> {
        const imagePreview = await this.createInstagramImagePreview(permalink);
        if (imagePreview) {
            if (snsPreviewManagerForm.getExistingPrimaryPreview(boardMediaArea)) return;
            placeholder.remove();
            boardMediaArea.appendChild(imagePreview);
            return;
        }

        if (snsPreviewManagerForm.getExistingPrimaryPreview(boardMediaArea)) return;
        placeholder.remove();
        CardPreviewTileRender.renderIndexSnsTilePreview(boardMediaArea, permalink);
    }

    private static async createInstagramImagePreview(permalink: string): Promise<HTMLElement | null> {
        const previewImageUrl = await ogpRender.fetchPreviewImageUrl(permalink);
        if (!previewImageUrl) return null;

        const container = document.createElement("div");
        container.className = "ogp-preview-card";
        container.setAttribute("data-role", Roles.OGP_PREVIEW_CARD);
        container.setAttribute("data-ogp-url", permalink);

        const content = document.createElement("div");
        content.className = "ogp-preview-card__content";

        const img = document.createElement("img");
        img.className = "ogp-preview-card__image";
        img.src = previewImageUrl;
        img.alt = "Instagram preview";
        img.loading = "lazy";

        content.appendChild(img);
        container.appendChild(content);

        return container;
    }
}
